import { z } from 'zod';

const supportedLocales = ['en-US', 'sr-Latn'] as const;

export const AboutTranslation = z.object({
  locale: z.enum(supportedLocales, {
    message: 'VALIDATION__InvalidLocale',
  }),
  text: z.string().max(1500, 'VALIDATION__Max1500CharLimit'),
});
